export default __webpack_public_path__ + "static/media/opensea.f302dfc1.svg";